import { SpaceKind } from 'shared';

import { StringKey } from '../../../lang/index';
import { WorkspaceCardStatus } from '../types/data-room.types';

export const WORKSPACE_CARD_KIND_LABEL: Record<SpaceKind, StringKey> = {
  [SpaceKind.DATA_ROOM]: 'DATA_ROOM',
  [SpaceKind.VAULT]: 'VAULT_KIND',
  [SpaceKind.WORKSPACE]: 'WORKSPACE_KIND',
};

export const WORKSPACE_CARD_STATUS_LABEL: Record<WorkspaceCardStatus, StringKey> = {
  [WorkspaceCardStatus.ACTIVE]: 'ACTIVE',
  [WorkspaceCardStatus.INACTIVE]: 'INACTIVE',
  [WorkspaceCardStatus.LOCKED]: 'LOCKED',
};

export const WORKSPACE_CARD_STATUS_CLASS: Record<WorkspaceCardStatus, string> = {
  [WorkspaceCardStatus.ACTIVE]: 'bg-forest-50 text-forest-600',
  [WorkspaceCardStatus.INACTIVE]: 'bg-gray-100 text-gray-700',
  [WorkspaceCardStatus.LOCKED]: 'bg-sunbeam-50 text-sunbeam-600',
};
